import axios from "axios";

const API_BASE_URL = "https://zenoapi.com/api"; // Change this based on your backend URL

export const IMG_BASE_URL = "https://zenoapi.com";

export const Register = async (newsData) => {
  const response = await axios.post(
    `${API_BASE_URL}/auth/register/`, 
    newsData,
    { 
        headers: {
             'Content-Type': 'application/json'
            }
    },
);
  return response.data;
};


export const LoginReq = async (newsData) => {
  const response = await axios.post(
    `${API_BASE_URL}/auth/login/`, 
    newsData,
    { 
        headers: {
             'Content-Type': 'application/json' 
            }
    },
);
  return response.data;
};

export const getSelcomPesaAccount = async () => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/payments/selcompesa-account/`,
    {
        headers: {
             'Authorization': `Bearer ${token}`
            }
    },
);
  return response.data;
};

export const saveSelcomPesaAccount = async (accountData) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.post(
    `${API_BASE_URL}/payments/selcompesa-account/`,
    accountData,
    {
        headers: {
             'Content-Type': 'application/json',
             'Authorization': `Bearer ${token}`
            }
    },
);
  return response.data;
};

export const deleteSelcomPesaAccount = async () => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.delete(
    `${API_BASE_URL}/payments/selcompesa-account/`,
    {
        headers: {
             'Authorization': `Bearer ${token}`
            }
    },
);
  return response.data;
};


export const fetchUserTransactionsAndTransfers = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/payments/user/expenses/`, 
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const ApiKeyGen = async (newsData) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/auth/generate-api-key/`, 
    newsData,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};

export const fetchUserApiKeys = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/sms/user-api-keys/`, 
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};


export const fetchUserSenderIds = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/sms/sender-ids/`, 
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};


// // Simulate API delay
// const simulateDelay = () => new Promise(resolve => setTimeout(resolve, 3000));

// export const getSenderIds = async ({ page = 1, pageSize = 5, search = '', status  }) => {
//    // Filter data based on search term
//   await simulateDelay(); 
//   // Fetch the data first (await the function)
//   let filteredData = await fetchUserSenderIds();
//   if (search) {
//     const searchTerm = search.toLowerCase();
//     filteredData = fetchUserSenderIds?.filter(
//       sender => sender.sender_id.toLowerCase().includes(searchTerm)
//     );
//   }

    
//   if (status) {
//     filteredData = filteredData?.filter(sender => sender.verification_status === status);
//   }
  
//   // Paginate results
//   const startIndex = (page - 1) * pageSize;
//   const paginatedData = filteredData?.slice(startIndex, startIndex + pageSize);
  
//   return {
//     data: paginatedData,
//     total: filteredData?.length,
//     page,
//     pageSize,
//     totalPages: Math.ceil(filteredData?.length / pageSize)
//   };
// };


// Add a new sender ID
export const addSenderId = async (senderIdData) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/sms/sender-ids/ `, 
    senderIdData,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};


export const sendSms = async (smsData) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/sms/send/`, 
    smsData,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};

export const fetchUserSMSs = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/sms/messages/`, 
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const updatePin = async (pinData) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/sms/change-pin/`, 
    pinData,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};

export const updatePassword = async (passData) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/sms/change-password/`, 
    passData,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};

export const fetchUserInfo = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/sms/me/`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchMasterSummary = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/sms/master-summary/`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchAdminUsers = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/sms/users/`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchActivityLogs = async (params = {}) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/sms/activity-logs/`,
    {
      params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchAdminUserDetail = async (userId) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/sms/users/${userId}/`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchPaymentsActivityLogs = async (params = {}) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/payments/activity-logs/`,
    {
      params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchAdminCollections = async (params = {}) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/payments/admin/collections/`,
    {
      params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchAdminCollectionsSummary = async () => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/payments/admin/collections/summary/`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchAdminPayouts = async (params = {}) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/payments/admin/payouts/`,
    {
      params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchAdminPayoutsSummary = async () => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/payments/admin/payouts/summary/`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const fetchKycStatus = async () => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.get(
    `${API_BASE_URL}/sms/kyc/status/`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const submitKyc = async (formData) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.post(
    `${API_BASE_URL}/sms/kyc/submit/`,
    formData,
    {
      headers: {
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const startDiditVerification = async () => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token;
  const response = await axios.post(
    `${API_BASE_URL}/sms/kyc/didit/session/`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};


export const addNewInvoice = async (invoiceData) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/payments/invoices/`, 
    invoiceData,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};

export const fetchUserInvoices = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/payments/invoices/`, 
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const sendBulkSms = async (invoiceData) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/sms/bulk/`, 
    invoiceData,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};


export const createCardHolder = async (Data) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.post(
    `${API_BASE_URL}/payments/cardholders/`, 
    Data,
    { 
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
    },
);
  return response.data;
};

export const fetchUserCardHolders = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/payments/my_cardholders/`,

    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};
// https://zenoapi.com/api/sms/sender-ids/ 

export const eventCreate = async (data) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const res = await axios.post(
    `${API_BASE_URL}/payments/event-create/`, 
    data,
    { 
        headers: {
        // Do NOT set Content-Type manually when sending FormData
        'Content-Type': 'multipart/form-data' ,
        'Authorization': `Bearer ${token}`
      }
    },
  );
  return res.data;
};

// https://zenoapi.com/api/payments/event-create/


export const getEvents = async () => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const response = await axios.get(
    `${API_BASE_URL}/payments/events-list/`, 
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
  });
  return response.data;
};

export const forgotPassword = async (data) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const res = await axios.post(
    `${API_BASE_URL}/password-reset-request/`, 
    data,
    { 
        headers: {
            'Content-Type': 'application/json',
            
          }
    },
  );
  return res.data;
};

export const calculateExchangeRate = async (data) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const res = await axios.post(
    `${API_BASE_URL}/payments/exchange-rate/ `, 
    data,
    { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`  
        }
    },
  );
  return res.data;
};


export const CurrencyExhangeRate = async (data) => {
  const userDataString = localStorage.getItem('userData'); // <--- moved inside function
  const userData = JSON.parse(userDataString);
  const token = userData?.tokens?.access?.token; // safe chaining
  const res = await axios.post(
    `${API_BASE_URL}/payments/transfer-currency/ `, 
    data,
    { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`  
        }
    },
  );
  return res.data;
};


// ---------------------------------------------------------------------------
// Virtual cards
// ---------------------------------------------------------------------------

const cardAuth = () => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${userData?.tokens?.access?.token}`,
  };
};

export const fetchCardWallet = async () => {
  const r = await axios.get(`${API_BASE_URL}/payments/cards/wallet/`, { headers: cardAuth() });
  return r.data;
};

export const topUpCardWallet = async (payload) => {
  const r = await axios.post(`${API_BASE_URL}/payments/cards/wallet/`, payload, { headers: cardAuth() });
  return r.data;
};

export const fetchCardQuote = async (params = {}) => {
  const r = await axios.get(`${API_BASE_URL}/payments/cards/quote/`, { params, headers: cardAuth() });
  return r.data;
};

export const fetchCardProducts = async () => {
  const r = await axios.get(`${API_BASE_URL}/payments/cards/products/`, { headers: cardAuth() });
  return r.data;
};

export const fetchCards = async () => {
  const r = await axios.get(`${API_BASE_URL}/payments/cards/`, { headers: cardAuth() });
  return r.data;
};

export const createCard = async (payload) => {
  const r = await axios.post(`${API_BASE_URL}/payments/cards/`, payload, { headers: cardAuth() });
  return r.data;
};

export const fetchCardDetail = async (cardId) => {
  const r = await axios.get(`${API_BASE_URL}/payments/cards/${cardId}/`, { headers: cardAuth() });
  return r.data;
};

export const fetchCardTransactions = async (cardId, params = {}) => {
  const r = await axios.get(`${API_BASE_URL}/payments/cards/${cardId}/transactions/`,
    { params, headers: cardAuth() });
  return r.data;
};

// action is fund, freeze or unfreeze
export const cardAction = async ({ cardId, action, payload = {} }) => {
  const r = await axios.post(`${API_BASE_URL}/payments/cards/${cardId}/${action}/`, payload,
    { headers: cardAuth() });
  return r.data;
};

export const terminateCard = async ({ cardId, pin, reason }) => {
  const r = await axios.delete(`${API_BASE_URL}/payments/cards/${cardId}/`,
    { headers: cardAuth(), data: { pin, reason } });
  return r.data;
};

// ---------------------------------------------------------------------------
// Terms acceptance
// ---------------------------------------------------------------------------

export const fetchTermsStatus = async () => {
  const r = await axios.get(`${API_BASE_URL}/sms/terms/`, { headers: cardAuth() });
  return r.data;
};

export const acceptTerms = async (version) => {
  const r = await axios.post(`${API_BASE_URL}/sms/terms/`, { version }, { headers: cardAuth() });
  return r.data;
};

// ---------------------------------------------------------------------------
// Expense tracker
// ---------------------------------------------------------------------------

export const fetchExpenseWallets = async () => {
  const r = await axios.get(`${API_BASE_URL}/expenses/wallets/`, { headers: cardAuth() });
  return r.data;
};

export const createExpenseWallet = async (payload) => {
  const r = await axios.post(`${API_BASE_URL}/expenses/wallets/`, payload, { headers: cardAuth() });
  return r.data;
};

export const updateExpenseWallet = async ({ id, ...payload }) => {
  const r = await axios.patch(`${API_BASE_URL}/expenses/wallets/${id}/`, payload, { headers: cardAuth() });
  return r.data;
};

export const deleteExpenseWallet = async (id) => {
  const r = await axios.delete(`${API_BASE_URL}/expenses/wallets/${id}/`, { headers: cardAuth() });
  return r.data;
};

export const fetchExpenses = async (params = {}) => {
  const r = await axios.get(`${API_BASE_URL}/expenses/`, { params, headers: cardAuth() });
  return r.data;
};

export const createExpense = async (payload) => {
  const r = await axios.post(`${API_BASE_URL}/expenses/`, payload, { headers: cardAuth() });
  return r.data;
};

export const updateExpense = async ({ id, ...payload }) => {
  const r = await axios.patch(`${API_BASE_URL}/expenses/${id}/`, payload, { headers: cardAuth() });
  return r.data;
};

export const deleteExpense = async (id) => {
  const r = await axios.delete(`${API_BASE_URL}/expenses/${id}/`, { headers: cardAuth() });
  return r.data;
};

export const fetchExpenseSummary = async (params = {}) => {
  const r = await axios.get(`${API_BASE_URL}/expenses/summary/`, { params, headers: cardAuth() });
  return r.data;
};

export const fetchExpenseCurrencies = async () => {
  const r = await axios.get(`${API_BASE_URL}/expenses/currencies/`, { headers: cardAuth() });
  return r.data;
};

export const fetchExpensePreferences = async () => {
  const r = await axios.get(`${API_BASE_URL}/expenses/preferences/`, { headers: cardAuth() });
  return r.data;
};

export const updateExpensePreferences = async (payload) => {
  const r = await axios.patch(`${API_BASE_URL}/expenses/preferences/`, payload, { headers: cardAuth() });
  return r.data;
};

// Products / services (buy price vs sell price, for business wallets)
export const fetchProducts = async (params = {}) => {
  const r = await axios.get(`${API_BASE_URL}/expenses/products/`, { params, headers: cardAuth() });
  return r.data;
};

export const createProduct = async (payload) => {
  const r = await axios.post(`${API_BASE_URL}/expenses/products/`, payload, { headers: cardAuth() });
  return r.data;
};

export const updateProduct = async ({ id, ...payload }) => {
  const r = await axios.patch(`${API_BASE_URL}/expenses/products/${id}/`, payload, { headers: cardAuth() });
  return r.data;
};

export const deleteProduct = async (id) => {
  const r = await axios.delete(`${API_BASE_URL}/expenses/products/${id}/`, { headers: cardAuth() });
  return r.data;
};

// Income (optionally linked to a product/service sale)
export const fetchIncomeEntries = async (params = {}) => {
  const r = await axios.get(`${API_BASE_URL}/expenses/income/`, { params, headers: cardAuth() });
  return r.data;
};

export const createIncome = async (payload) => {
  const r = await axios.post(`${API_BASE_URL}/expenses/income/`, payload, { headers: cardAuth() });
  return r.data;
};

export const updateIncome = async ({ id, ...payload }) => {
  const r = await axios.patch(`${API_BASE_URL}/expenses/income/${id}/`, payload, { headers: cardAuth() });
  return r.data;
};

export const deleteIncome = async (id) => {
  const r = await axios.delete(`${API_BASE_URL}/expenses/income/${id}/`, { headers: cardAuth() });
  return r.data;
};

export const fetchIncomeSummary = async (params = {}) => {
  const r = await axios.get(`${API_BASE_URL}/expenses/income/summary/`, { params, headers: cardAuth() });
  return r.data;
};
